import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import Navbar from './Navbar';
import { events } from '../utils/analytics';
import { PageSEO, softwareAppSchema } from '../utils/seo';

/* ─── Image data ─── */
const bannerData = [
  { image: '/images/icoach/cell_user_1.webp' },
  { image: '/images/icoach/cell_master_1.webp' },
  { image: '/images/icoach/cell_master_2.webp' },
  { image: '/images/icoach/cell_master_3.webp' },
];
const bannerDataTablet = [
  { image: '/images/icoach/tablet_1.webp' },
  { image: '/images/icoach/tablet_2.webp' },
  { image: '/images/icoach/tablet_3.webp' },
];

/* ─── Feature data ─── */
const trainers = [
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Gestione clienti 360°',
    desc: 'Dashboard intuitive per ogni aspetto del percorso fitness dei tuoi atleti, tutto in un unico posto.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
    title: 'Schede personalizzate',
    desc: 'Editor avanzato con libreria esercizi integrata per costruire programmi su misura per ogni atleta.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    title: 'Pianificazione nutrizionale',
    desc: 'Piani alimentari e di integrazione dettagliati, pensati per supportare gli obiettivi di ogni cliente.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.069A1 1 0 0121 8.82V15a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Libreria video esercizi',
    desc: 'Carica e condividi dimostrazioni video precise per ogni esercizio, riducendo gli errori di esecuzione.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Monitoraggio progressi',
    desc: 'Grafici e statistiche avanzate per analizzare l\'andamento dei tuoi clienti in tempo reale.',
  },
];

const athletes = [
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Accesso immediato',
    desc: 'Consulta il tuo programma ovunque tu sia, anche offline senza connessione internet.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Video-guida esercizi',
    desc: 'Perfeziona la tecnica con i video dettagliati del tuo trainer, disponibili in qualsiasi momento.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
    title: 'Tracciamento progressi',
    desc: 'Registra i tuoi miglioramenti sessione per sessione e mantieni alta la motivazione.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    title: 'Piano nutrizionale',
    desc: 'Segui la dieta con promemoria intelligenti, liste della spesa e tracking calorico integrato.',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
    title: 'Comunicazione diretta',
    desc: 'Feedback immediati e supporto diretto dal tuo trainer, senza intermediari.',
  },
];

/* ─── Stats ─── */
const statsData = [
  { target: 10000, suffix: '+', label: 'Utenti attivi' },
  { target: 500,   suffix: '+', label: 'Personal Trainer' },
  { target: 98,    suffix: '%', label: 'Soddisfazione' },
  { target: 24,    suffix: '/7', label: 'Supporto' },
];

/* ─── Count-up hook ─── */
function useCountUp(target, suffix, isVisible) {
  const [display, setDisplay] = useState('0');
  useEffect(() => {
    if (!isVisible) return;
    const duration = 1600;
    const steps = 52;
    const step = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current = Math.min(current + step, target);
      setDisplay(
        target >= 1000
          ? `${(current / 1000).toFixed(current >= target ? 0 : 1)}K${suffix}`
          : `${Math.round(current)}${suffix}`
      );
      if (current >= target) clearInterval(timer);
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isVisible, target, suffix]);
  return display;
}

/* ─── Reveal component ─── */
function Reveal({ children, delay = 0, y = 24 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.72, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

/* ─── Stat card ─── */
function StatCard({ stat }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });
  const value = useCountUp(stat.target, stat.suffix, inView);
  return (
    <div
      ref={ref}
      style={{
        background: 'rgba(13,13,24,0.8)',
        border: '1px solid rgba(255,255,255,0.08)',
        backdropFilter: 'blur(20px)',
        borderRadius: '20px',
        padding: '32px 24px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, #22d3ee, rgba(34,211,238,0.2))' }} />
      <div style={{
        fontFamily: 'var(--font-mono)',
        fontSize: 'clamp(2rem, 4vw, 2.6rem)',
        fontWeight: 700,
        background: 'linear-gradient(135deg, #22d3ee 0%, #a78bfa 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        lineHeight: 1,
        marginBottom: '10px',
      }}>
        {value}
      </div>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--color-muted)', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
        {stat.label}
      </div>
    </div>
  );
}

/* ─── Feature card ─── */
function FeatureCard({ feat, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Reveal delay={index * 0.07}>
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          background: hovered ? 'rgba(13,13,24,0.95)' : 'rgba(13,13,24,0.8)',
          border: `1px solid ${hovered ? 'rgba(34,211,238,0.25)' : 'rgba(255,255,255,0.08)'}`,
          backdropFilter: 'blur(20px)',
          borderRadius: '20px',
          padding: '28px',
          transition: 'all 0.25s ease',
          transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
          boxShadow: hovered ? '0 16px 40px rgba(34,211,238,0.08)' : 'none',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {hovered && (
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
            background: 'linear-gradient(90deg, transparent, #22d3ee, transparent)',
          }} />
        )}
        <div style={{
          width: '44px', height: '44px',
          borderRadius: '12px',
          background: hovered ? 'rgba(34,211,238,0.12)' : 'rgba(34,211,238,0.07)',
          border: `1px solid ${hovered ? 'rgba(34,211,238,0.3)' : 'rgba(34,211,238,0.15)'}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#22d3ee',
          marginBottom: '18px',
          transition: 'all 0.25s ease',
          boxShadow: hovered ? '0 0 16px rgba(34,211,238,0.2)' : 'none',
        }}>
          {feat.icon}
        </div>
        <h3 style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1rem',
          fontWeight: 700,
          color: 'var(--color-text)',
          marginBottom: '8px',
          lineHeight: 1.3,
        }}>
          {feat.title}
        </h3>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.875rem',
          color: 'var(--color-muted)',
          lineHeight: 1.7,
          margin: 0,
        }}>
          {feat.desc}
        </p>
      </div>
    </Reveal>
  );
}

/* ─── Main component ─── */
export default function Icoach() {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [activeTabletIndex, setActiveTabletIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('trainers');

  useEffect(() => {
    window.scrollTo(0, 0);
    const i1 = setInterval(() => setActiveImageIndex(p => (p + 1) % bannerData.length), 4000);
    const i2 = setInterval(() => setActiveTabletIndex(p => (p + 1) % bannerDataTablet.length), 4500);
    return () => { clearInterval(i1); clearInterval(i2); };
  }, []);

  return (
    <>
      <PageSEO
        title="iCoach — App Allenamento Personale"
        description="iCoach è l'app mobile per il fitness che connette trainer e atleti. Programmi di allenamento personalizzati, monitoraggio progressi e comunicazione diretta. Disponibile su iOS e Android."
        canonical="/icoach"
        jsonLd={softwareAppSchema({
          name: 'iCoach',
          description: 'App mobile per il fitness che connette trainer e atleti con programmi di allenamento personalizzati e monitoraggio progressi.',
          url: 'https://vmdproject.com/icoach',
          operatingSystem: 'iOS, Android',
          applicationCategory: 'HealthAndFitnessApplication',
          image: bannerData[0].image,
          price: '0', // gratis su App Store e Google Play
        })}
      />
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.45, ease: 'easeInOut' }}
        style={{
          background: 'var(--color-bg)',
          minHeight: '100vh',
          fontFamily: 'var(--font-body)',
          overflowX: 'hidden',
        }}
      >

        {/* ── HERO ── */}
        <section style={{
          paddingTop: 'calc(68px + 5rem)',
          paddingBottom: '6rem',
          padding: 'calc(68px + 5rem) 0 6rem',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Background blobs */}
          <div style={{
            position: 'absolute', top: '-200px', right: '-200px',
            width: '600px', height: '600px',
            background: 'radial-gradient(circle, rgba(34,211,238,0.06) 0%, transparent 65%)',
            borderRadius: '50%', pointerEvents: 'none',
          }} />
          <div style={{
            position: 'absolute', bottom: '-100px', left: '-100px',
            width: '500px', height: '500px',
            background: 'radial-gradient(circle, rgba(124,58,237,0.07) 0%, transparent 65%)',
            borderRadius: '50%', pointerEvents: 'none',
          }} />

          <div className="container" style={{ display: 'flex', alignItems: 'center', gap: '4rem', flexWrap: 'wrap' }}>
            {/* Left — text */}
            <motion.div
              initial={{ opacity: 0, y: 32 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
              style={{ flex: '1', minWidth: '300px' }}
            >
              {/* Mono label */}
              <div style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                color: '#22d3ee',
                letterSpacing: '2.5px',
                textTransform: 'uppercase',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}>
                <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#22d3ee', boxShadow: '0 0 10px #22d3ee' }} />
                {'// icoach'}
              </div>

              <h1 style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(2.4rem, 5.5vw, 3.8rem)',
                fontWeight: 800,
                color: 'var(--color-text)',
                lineHeight: 1.08,
                letterSpacing: '-1.5px',
                marginBottom: '1.25rem',
              }}>
                L'app che trasforma il{' '}
                <span style={{
                  background: 'linear-gradient(135deg, #22d3ee 0%, #a78bfa 60%, #f472b6 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}>
                  fitness
                </span>{' '}
                personale.
              </h1>

              <p style={{
                fontFamily: 'var(--font-body)',
                fontSize: '1.05rem',
                color: 'var(--color-text-2)',
                lineHeight: 1.75,
                maxWidth: '480px',
                marginBottom: '2.5rem',
              }}>
                La piattaforma completa che connette personal trainer e atleti — schede, nutrizione, progressi e comunicazione in un'unica app.
              </p>

              {/* Store buttons */}
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '3rem' }}>
                <StoreButton
                  href="https://apps.apple.com/us/app/icoach-exclusivelab/id6736830478"
                  label="App Store"
                  sub="Scarica su"
                  icon={
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                  }
                />
                <StoreButton
                  href="https://play.google.com/store/apps/details?id=com.icoach.iCoachEclusiveLab&hl=it"
                  label="Google Play"
                  sub="Disponibile su"
                  icon={
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3.18 23.76c.33.19.7.24 1.06.14l12.04-6.95-2.56-2.56-10.54 9.37zm-1.11-20.1c-.05.17-.07.36-.07.57v19.54c0 .21.02.4.07.57l.1.09 10.95-10.95v-.26L2.17 3.57l-.1.09zM20.04 10.8l-2.76-1.59-2.93 2.93 2.93 2.93 2.78-1.6c.79-.46.79-1.21-.02-1.67zm-18.87 11.9l12.37-12.37-2.56-2.56L1.06 20.13c-.37.33-.42.88-.1 1.25l.21.32z"/>
                    </svg>
                  }
                />
              </div>

              {/* Mini stats row */}
              <div style={{ display: 'flex', gap: '28px', flexWrap: 'wrap' }}>
                {statsData.map(s => (
                  <div key={s.label}>
                    <div style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '1.3rem',
                      fontWeight: 700,
                      color: '#22d3ee',
                      lineHeight: 1,
                    }}>
                      {s.target >= 1000 ? `${s.target / 1000}K${s.suffix}` : `${s.target}${s.suffix}`}
                    </div>
                    <div style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '10px',
                      color: 'var(--color-muted)',
                      marginTop: '4px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                    }}>
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Right — phone mockup */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
              style={{ flex: '1', minWidth: '260px', display: 'flex', justifyContent: 'center' }}
            >
              <div style={{ position: 'relative', width: '260px' }}>
                {/* Glow behind phone */}
                <div style={{
                  position: 'absolute', top: '50%', left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '320px', height: '320px',
                  background: 'radial-gradient(circle, rgba(34,211,238,0.12) 0%, transparent 70%)',
                  borderRadius: '50%', pointerEvents: 'none',
                }} />
                {/* Phone shell */}
                <motion.div
                  animate={{ y: [0, -14, 0] }}
                  transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
                  style={{ position: 'relative', zIndex: 1 }}
                >
                  <div style={{
                    background: 'rgba(13,13,24,0.9)',
                    borderRadius: '44px',
                    padding: '10px',
                    border: '1px solid rgba(34,211,238,0.18)',
                    boxShadow: '0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06), 0 0 60px rgba(34,211,238,0.06)',
                  }}>
                    <img
                      src={bannerData[activeImageIndex]?.image}
                      alt="iCoach App"
                      style={{ width: '100%', borderRadius: '36px', display: 'block', transition: 'opacity 0.5s ease' }}
                    />
                  </div>
                </motion.div>
                {/* Dots */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '7px', marginTop: '20px', position: 'relative', zIndex: 1 }}>
                  {bannerData.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveImageIndex(i)}
                      style={{
                        width: i === activeImageIndex ? '22px' : '7px',
                        height: '7px',
                        borderRadius: '4px',
                        background: i === activeImageIndex ? '#22d3ee' : 'rgba(255,255,255,0.2)',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        padding: 0,
                        boxShadow: i === activeImageIndex ? '0 0 8px rgba(34,211,238,0.5)' : 'none',
                      }}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* ── STATS ── */}
        <section className="section" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
          <div className="container">
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '16px',
            }}>
              {statsData.map(s => <StatCard key={s.label} stat={s} />)}
            </div>
          </div>
        </section>

        {/* ── FEATURES ── */}
        <section id="features" className="section">
          <div className="container">
            <Reveal>
              <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
                <div style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: '11px',
                  color: '#22d3ee',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  marginBottom: '16px',
                }}>
                  {'// funzionalità'}
                </div>
                <h2 style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'clamp(1.9rem, 4vw, 2.8rem)',
                  fontWeight: 800,
                  color: 'var(--color-text)',
                  letterSpacing: '-1px',
                  lineHeight: 1.1,
                  marginBottom: '1rem',
                }}>
                  Due esperienze,{' '}
                  <span style={{ background: 'var(--gradient-text)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                    una piattaforma
                  </span>
                </h2>
                <p style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '1rem',
                  color: 'var(--color-muted)',
                  maxWidth: '480px',
                  margin: '0 auto 2rem',
                  lineHeight: 1.7,
                }}>
                  Interfacce dedicate per trainer e atleti, ottimizzate per ciascun ruolo.
                </p>

                {/* Tab switcher */}
                <div style={{
                  display: 'inline-flex',
                  background: 'rgba(13,13,24,0.8)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: '50px',
                  padding: '5px',
                  gap: '4px',
                }}>
                  {[['trainers', 'Trainer'], ['athletes', 'Atleti']].map(([key, label]) => (
                    <button
                      key={key}
                      onClick={() => setActiveTab(key)}
                      style={{
                        padding: '9px 24px',
                        borderRadius: '50px',
                        border: 'none',
                        background: activeTab === key
                          ? 'linear-gradient(135deg, rgba(34,211,238,0.15), rgba(124,58,237,0.15))'
                          : 'transparent',
                        color: activeTab === key ? '#22d3ee' : 'var(--color-muted)',
                        fontFamily: 'var(--font-mono)',
                        fontSize: '12px',
                        fontWeight: 600,
                        letterSpacing: '0.5px',
                        cursor: 'pointer',
                        transition: 'all 0.22s ease',
                        boxShadow: activeTab === key ? '0 0 0 1px rgba(34,211,238,0.2)' : 'none',
                        textTransform: 'uppercase',
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </Reveal>

            {/* Feature grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '16px',
            }}>
              {(activeTab === 'trainers' ? trainers : athletes).map((f, i) => (
                <FeatureCard key={f.title} feat={f} index={i} />
              ))}
            </div>
          </div>
        </section>

        {/* ── SCREENSHOTS ── */}
        <section id="screenshots" className="section">
          <div className="container">
            <Reveal>
              <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
                <div style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: '11px',
                  color: '#22d3ee',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  marginBottom: '16px',
                }}>
                  {'// interfaccia'}
                </div>
                <h2 style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'clamp(1.9rem, 4vw, 2.8rem)',
                  fontWeight: 800,
                  color: 'var(--color-text)',
                  letterSpacing: '-1px',
                  lineHeight: 1.1,
                  marginBottom: '1rem',
                }}>
                  Design moderno,{' '}
                  <span style={{ background: 'var(--gradient-text)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                    ogni dispositivo
                  </span>
                </h2>
                <p style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '1rem',
                  color: 'var(--color-muted)',
                  maxWidth: '420px',
                  margin: '0 auto',
                  lineHeight: 1.7,
                }}>
                  Ottimizzata per smartphone e tablet, l'app garantisce un'esperienza fluida su ogni schermo.
                </p>
              </div>
            </Reveal>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '24px',
              alignItems: 'start',
            }}>
              {[
                { label: 'Smartphone', data: bannerData, active: activeImageIndex, setActive: setActiveImageIndex, maxH: '380px' },
                { label: 'Tablet', data: bannerDataTablet, active: activeTabletIndex, setActive: setActiveTabletIndex, maxH: '260px' },
              ].map(({ label, data, active, setActive, maxH }) => (
                <Reveal key={label}>
                  <div style={{
                    background: 'rgba(13,13,24,0.8)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '20px',
                    padding: '28px',
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                  }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, #22d3ee, rgba(34,211,238,0.2))' }} />
                    <div style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '11px',
                      color: '#22d3ee',
                      letterSpacing: '2px',
                      textTransform: 'uppercase',
                      marginBottom: '20px',
                    }}>
                      {'// '}{label.toLowerCase()}
                    </div>
                    <img
                      src={data[active]?.image}
                      alt={label}
                      style={{
                        maxHeight: maxH,
                        width: 'auto',
                        borderRadius: '12px',
                        display: 'block',
                        margin: '0 auto',
                        transition: 'opacity 0.4s ease',
                        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
                      }}
                    />
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '7px' }}>
                      {data.map((_, i) => (
                        <button
                          key={i}
                          onClick={() => setActive(i)}
                          style={{
                            width: i === active ? '20px' : '7px',
                            height: '7px',
                            borderRadius: '4px',
                            border: 'none',
                            background: i === active ? '#22d3ee' : 'rgba(255,255,255,0.15)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            padding: 0,
                            boxShadow: i === active ? '0 0 8px rgba(34,211,238,0.4)' : 'none',
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section id="cta" className="section">
          <div className="container">
            <Reveal>
              <div style={{
                background: 'rgba(13,13,24,0.8)',
                border: '1px solid rgba(255,255,255,0.08)',
                backdropFilter: 'blur(20px)',
                borderRadius: '28px',
                padding: 'clamp(2.5rem, 5vw, 4rem)',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
              }}>
                {/* Glow */}
                <div style={{
                  position: 'absolute', top: '-80px', left: '50%', transform: 'translateX(-50%)',
                  width: '500px', height: '300px',
                  background: 'radial-gradient(ellipse, rgba(34,211,238,0.06) 0%, transparent 70%)',
                  pointerEvents: 'none',
                }} />
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg, transparent, #22d3ee, transparent)' }} />

                <div style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: '11px',
                  color: '#22d3ee',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  marginBottom: '20px',
                }}>
                  {'// personalizzazione completa'}
                </div>

                <h2 style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
                  fontWeight: 800,
                  letterSpacing: '-1px',
                  lineHeight: 1.1,
                  marginBottom: '1rem',
                  background: 'var(--gradient-text)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}>
                  Costruiamo la tua versione di iCoach.
                </h2>
                <p style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '1rem',
                  color: 'var(--color-text-2)',
                  maxWidth: '520px',
                  margin: '0 auto 2.5rem',
                  lineHeight: 1.75,
                }}>
                  Palestre, trainer indipendenti, brand del fitness — creiamo la versione perfetta per le tue esigenze.
                </p>

                {/* 4 benefit mini-cards */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                  gap: '12px',
                  maxWidth: '680px',
                  margin: '0 auto 2.5rem',
                }}>
                  {[
                    { icon: '◈', label: 'Brand personalizzato' },
                    { icon: '⚙', label: 'Funzioni su misura' },
                    { icon: '◉', label: 'Supporto dedicato' },
                    { icon: '→', label: 'Deploy rapido' },
                  ].map(b => (
                    <div key={b.label} style={{
                      background: 'rgba(34,211,238,0.04)',
                      border: '1px solid rgba(34,211,238,0.1)',
                      borderRadius: '14px',
                      padding: '18px 14px',
                      textAlign: 'center',
                    }}>
                      <div style={{
                        fontFamily: 'var(--font-mono)',
                        fontSize: '20px',
                        color: '#22d3ee',
                        marginBottom: '8px',
                        opacity: 0.8,
                      }}>
                        {b.icon}
                      </div>
                      <div style={{
                        fontFamily: 'var(--font-mono)',
                        fontSize: '11px',
                        color: 'var(--color-muted)',
                        letterSpacing: '0.5px',
                        lineHeight: 1.4,
                      }}>
                        {b.label}
                      </div>
                    </div>
                  ))}
                </div>

                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Link to="/collabora" className="btn-primary" style={{ display: 'inline-flex', textDecoration: 'none', fontSize: '0.95rem' }} onClick={() => events.productCta('icoach')}>
                    Richiedi una demo
                    <svg width="13" height="13" viewBox="0 0 12 12" fill="none" style={{ marginLeft: '8px' }}>
                      <path d="M1 6h10M7 2l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Link>
                  <Link to="/icoach/policy" className="btn-secondary">Privacy Policy</Link>
                  <Link to="/icoach/terms" className="btn-secondary">Termini d'uso</Link>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ── FOOTER ── */}
        <footer style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          padding: '3rem 0',
        }}>
          <div className="container" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '16px',
          }}>
            <span style={{
              fontFamily: 'var(--font-mono)',
              fontSize: '12px',
              color: 'var(--color-muted)',
              letterSpacing: '0.5px',
            }}>
              VMDProject · © 2026
            </span>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
              <Link to="/progetti" style={{
                fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--color-muted)',
                textDecoration: 'none', letterSpacing: '1px', textTransform: 'uppercase',
              }}>
                Tutti i progetti
              </Link>
              <Link to="/icoach/policy" style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                color: 'var(--color-muted)',
                textDecoration: 'none',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = '#22d3ee'}
                onMouseLeave={e => e.target.style.color = 'var(--color-muted)'}
              >
                Privacy
              </Link>
              <Link to="/icoach/terms" style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                color: 'var(--color-muted)',
                textDecoration: 'none',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = '#22d3ee'}
                onMouseLeave={e => e.target.style.color = 'var(--color-muted)'}
              >
                Termini
              </Link>
            </div>
          </div>
        </footer>

      </motion.main>
    </>
  );
}

/* ─── Store button ─── */
function StoreButton({ href, label, sub, icon }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={() => window.open(href, '_blank', 'noopener')}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: hovered ? 'rgba(34,211,238,0.08)' : 'rgba(13,13,24,0.8)',
        border: `1px solid ${hovered ? 'rgba(34,211,238,0.3)' : 'rgba(255,255,255,0.1)'}`,
        color: 'var(--color-text)',
        padding: '13px 22px',
        borderRadius: '14px',
        cursor: 'pointer',
        backdropFilter: 'blur(12px)',
        transition: 'all 0.22s ease',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: hovered ? '0 10px 28px rgba(34,211,238,0.12)' : '0 4px 16px rgba(0,0,0,0.3)',
      }}
    >
      <span style={{ color: hovered ? '#22d3ee' : 'var(--color-text-2)', transition: 'color 0.22s' }}>
        {icon}
      </span>
      <div style={{ textAlign: 'left' }}>
        <div style={{
          fontFamily: 'var(--font-mono)',
          fontSize: '9px',
          color: 'var(--color-muted)',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          marginBottom: '2px',
        }}>
          {sub}
        </div>
        <div style={{
          fontFamily: 'var(--font-display)',
          fontSize: '15px',
          fontWeight: 700,
          letterSpacing: '-0.3px',
        }}>
          {label}
        </div>
      </div>
    </button>
  );
}
